'use client';

import { motion } from 'framer-motion';
import { ArrowRight, Clipboard, AlertCircle, Palette, BarChart3, Lightbulb, Compass } from 'lucide-react';

export function BentoSection() {
  const items = [
    {
      title: 'The Dawn of Innovation',
      description: 'Explore the birth of groundbreaking ideas and inventions.',
      icon: Lightbulb,
      span: 'col-span-1',
    },
    {
      title: 'The Digital Revolution',
      description: 'Dive into the transformative power of technology.',
      icon: Clipboard,
      span: 'col-span-1',
    },
    {
      title: 'The Art of Design',
      description: 'Discover the beauty of thoughtful and functional design.',
      icon: Palette,
      span: 'col-span-1',
    },
    {
      title: 'The Power of Communication',
      description: 'Understand the impact of effective communication in our lives.',
      icon: BarChart3,
      span: 'md:col-span-2',
    },
    {
      title: 'The Pursuit of Knowledge',
      description: 'Join the quest for understanding and enlightenment.',
      icon: AlertCircle,
      span: 'col-span-1',
    },
    {
      title: 'The Joy of Creation',
      description: 'Experience the thrill of bringing ideas to life.',
      icon: ArrowRight,
      span: 'col-span-1',
    },
    {
      title: 'The Spirit of Adventure',
      description: 'Embark on exciting journeys and thrilling discoveries.',
      icon: Compass,
      span: 'md:col-span-2',
    },
  ];

  return (
    <section className="relative w-full bg-white px-4 py-20 dark:bg-slate-950 md:py-32">
      <div className="mx-auto max-w-6xl">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-100px' }}
          transition={{ duration: 0.5 }}
          className="mb-16 text-center"
        >
          <h2 className="mb-4 text-4xl font-bold text-slate-900 dark:text-white md:text-5xl">
            Powerful Capabilities
          </h2>
          <p className="mx-auto max-w-2xl text-lg text-slate-600 dark:text-slate-400">
            Everything you need to succeed
          </p>
        </motion.div>

        <div className="grid grid-cols-1 gap-4 md:grid-cols-3">
          {items.map((item, index) => {
            const Icon = item.icon;
            return (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: '-50px' }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                className={`group relative min-h-[200px] overflow-hidden rounded-xl border border-slate-200 bg-white p-6 transition-all duration-300 hover:-translate-y-2 hover:border-blue-500 hover:shadow-xl dark:border-slate-700 dark:bg-slate-800 dark:hover:border-blue-500 ${item.span}`}
              >
                <div className="absolute -inset-0.5 rounded-xl bg-gradient-to-r from-blue-500 to-purple-500 opacity-0 blur-xl transition-all duration-500 group-hover:opacity-20" />
                <div className="relative flex h-full flex-col justify-between">
                  <div className="mb-4 flex h-10 w-10 items-center justify-center rounded-lg bg-blue-100 text-blue-600 dark:bg-blue-900/30 dark:text-blue-400">
                    <Icon className="h-5 w-5" />
                  </div>
                  <div>
                    <h3 className="mb-2 text-lg font-bold text-slate-900 dark:text-white">{item.title}</h3>
                    <p className="text-sm text-slate-600 dark:text-slate-400">{item.description}</p>
                  </div>
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
